import { AppProvider } from '@kcftech/design-system';
import { MouseEventHandler, ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

type LinkLikeProps = {
    external?: boolean;
    url?: string;
    children?: ReactNode;
    onClick?: MouseEventHandler<HTMLAnchorElement>;
    className?: string;
    download?: string | boolean;
};

/**
 * Every link created from the design system will use this LinkComponent
 * to render a link.
 */
function LinkComponent(props: LinkLikeProps) {
    const { external, url, children, onClick, ...rest } = props;
    if (external) {
        return (
            <a
                {...rest}
                onClick={onClick}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
            >
                {children}
            </a>
        );
    }
    if (url) {
        return (
            <NavLink to={url} onClick={onClick} {...rest}>
                {children}
            </NavLink>
        );
    }
    throw new Error(
        'Rendered a link without a URL, is the LinkComponent configured correctly?',
    );
}

export type ConfiguredAppProviderProps = { children?: ReactNode; className?: string };

export function ConfiguredAppProvider({
    children,
    className,
}: ConfiguredAppProviderProps) {
    return (
        <AppProvider linkComponent={LinkComponent} className={className}>
            {children}
        </AppProvider>
    );
}
